<div class="modal-body review-reason-modal-body px-5 pt-5 pb-4 bg-white">
  <div class="flex items-start gap-4 mb-4">
    <div>
      @if(data.action === 'accept'){
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-[50px] h-[50px] text-green-500">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      } @else if (data.action === 'reject') {
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-[50px] h-[50px] text-red-500">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      }
    </div>
    <div class="flex-1">
      <h2 class="text-gray-700 text-xl font-semibold mb-2">
        {{ data.title }}
      </h2>
      <p class="text-gray-600 text-sm mb-4" [innerHTML]="data.message | safeHtml"></p>
      <div class="mt-4">
        <label class="block text-sm font-medium text-gray-700 mb-2">
          {{ reasonFieldLabel }}
        </label>
        <textarea
          [(ngModel)]="reason"
          [attr.rows]="4"
          placeholder="Enter a reason for this action..."
          class="review-reason-textarea mt-1 block w-full pl-3 pr-3 py-2 text-base border border-gray-300 bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-lg resize-none transition-shadow">
        </textarea>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer flex justify-end gap-3 px-5 pb-5 bg-white">
  <button
    type="button"
    class="bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 px-5 py-2.5 focus:outline-none focus:ring-2 focus:ring-gray-400 transition-colors"
    (click)="onCancel()">
    {{ cancelLabel }}
  </button>
  <button
    type="button"
    [class]="data.action === 'accept' ? 'bg-green-600 text-white rounded-lg hover:bg-green-700 px-5 py-2.5 focus:outline-none focus:ring-2 focus:ring-green-500 transition-colors' : 'bg-red-600 text-white rounded-lg hover:bg-red-700 px-5 py-2.5 focus:outline-none focus:ring-2 focus:ring-red-500 transition-colors'"
    (click)="onConfirm()">
    {{ confirmLabel }}
  </button>
</div>
